import classnames from 'classnames';
import { forwardRef } from 'react';
import { SvgIcon } from './SvgIcon';

export const SearchInput = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ placeholder, className, ...props }, ref) => {
  return (
    <div
      className={classnames(
        'flex items-center flex-nowrap w-full px-3 h-9 rounded-sm all-unset border border-[#e4e4e7]',
        className,
      )}
    >
      <SvgIcon name="search" />
      <input
        ref={ref}
        className="w-full border bg-none ml-1 text-md font-normal placeholder:font-light reset-all"
        {...props}
        type="text"
        placeholder={placeholder ?? 'Поиск'}
        name={props.id ?? 'search'}
      />
    </div>
  );
});

SearchInput.displayName = 'SearchInput';
